import { render, staticRenderFns } from "./SlicePetition.vue?vue&type=template&id=a269bfdc&scoped=true"
import script from "./SlicePetition.vue?vue&type=script&lang=js"
export * from "./SlicePetition.vue?vue&type=script&lang=js"
import style0 from "./SlicePetition.vue?vue&type=style&index=0&id=a269bfdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a269bfdc",
  null
  
)

export default component.exports